import styled from 'styled-components';
import { media } from '../../common/theme/media';

export const CenterWrapper = styled.div<{ $imageOverlay?: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${({ theme, $imageOverlay }) => ($imageOverlay ? '0' : `${theme.spaces.space4} 0 0`)};
  margin-bottom: ${({ theme, $imageOverlay }) => ($imageOverlay ? '0' : `-${theme.spaces.space3}`)};

  ${media.desktop`
    padding: ${({ theme }) => theme.spaces.space4} 0;
    margin-bottom: 0;
  `}
`;
